module.exports = __webpack_public_path__ + "static/media/SenaryoBG.bc960fad.jpg";